import { HelmetProvider } from 'react-helmet-async';
import {
	createBrowserRouter,
	RouterProvider,
	Navigate,
} from 'react-router-dom';
import './App.css';

import styles from './App.module.css';

import { Home } from './home/Home';

import IssueView from '../../views/issue/Issue';
import { Auth } from './auth/Auth';
import config from '../../config';
import { Callback } from './callback/Callback';

import Drafts from '../../views/drafts/Drafts';
import { Logout } from './auth/Logout';
import { useInterval } from '../../App.hooks';
import { tryRefreshToken, useRefreshOnBuild, logOut } from './auth/Auth.hooks';
import { IS_AUTHENTICATED_KEY } from '@/auth/constants';

function App() {
	const basename = config?.build?.subdirectory
		? config.build.subdirectory
		: undefined;
	const INTERVAL_TIME = 60 * 1000;
	useRefreshOnBuild();
	useInterval(() => {
		tryRefreshToken('/', { minutes: 1 });
	}, INTERVAL_TIME);

	// TODO Remove to enable logout
	const onClickLogout = localStorage.getItem(IS_AUTHENTICATED_KEY)
		? () => {
				logOut('/logout');
		  }
		: undefined;
	// const onClickLogout = undefined;
	const routes = [
		{
			path: '/',
			element: (
				<Auth>
					<Home onClickLogOut={onClickLogout} />
				</Auth>
			),
		},
		{
			path: '/issues/:id',
			element: (
				<Auth>
					<IssueView onClickLogOut={onClickLogout} />
				</Auth>
			),
		},
		{
			path: '/issues/:id/:articleId',
			element: (
				<Auth>
					<IssueView onClickLogOut={onClickLogout} />
				</Auth>
			),
		},
		{
			path: '/callback',
			element: <Callback />,
		},
		{
			path: '/logout',
			element: <Logout />,
		},
		{
			path: '*',
			element: <Navigate to="/" replace />,
		},
	];

	if (config?.app?.admin) {
		routes.push({
			path: '/drafts',
			element: <Drafts />,
		});
	}

	routes.push({
		path: '*',
		element: <Navigate to="/" replace />,
	});

	const router = createBrowserRouter(routes, {
		basename,
	});

	const classNames = ['App', styles['app']];
	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

export default App;
